// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__32eTD","image":"styles_image__1P-VT","text":"styles_text__emBJ9"};